import type {
	ArtifactResponseJSON,
	CreateArtifactRequest,
	ListArtifactsResponseJSON,
	RenderRequest,
	RenderResponse,
	UpdateArtifactRequest,
} from "@performyard/service-contracts";

import request from "./internal-api/internal-base-request";

// GET /v1/reporting-chat/artifacts
export const getArtifacts = async (): Promise<ListArtifactsResponseJSON> => {
	const [response] = await request<ListArtifactsResponseJSON>("/v1/reporting-chat/artifacts", {
		method: "GET",
	});
	return response;
};

// GET /v1/reporting-chat/artifacts/:id
export const getArtifact = async (id: string): Promise<ArtifactResponseJSON> => {
	const [response] = await request<ArtifactResponseJSON>(`/v1/reporting-chat/artifacts/${id}`, {
		method: "GET",
	});
	return response;
};

// POST /v1/reporting-chat/artifacts
export const createArtifact = async (body: CreateArtifactRequest): Promise<ArtifactResponseJSON> => {
	const [response] = await request<ArtifactResponseJSON>("/v1/reporting-chat/artifacts", {
		method: "POST",
		body: JSON.stringify(body),
	});
	return response;
};

// PUT /v1/reporting-chat/artifacts/:id
export const updateArtifact = async (id: string, body: UpdateArtifactRequest): Promise<ArtifactResponseJSON> => {
	const [response] = await request<ArtifactResponseJSON>(`/v1/reporting-chat/artifacts/${id}`, {
		method: "PUT",
		body: JSON.stringify(body),
	});
	return response;
};

// POST /v1/reporting-chat/render
export const renderArtifact = async (body: RenderRequest): Promise<RenderResponse> => {
	const [response] = await request<RenderResponse>("/v1/reporting-chat/render", {
		method: "POST",
		body: JSON.stringify(body),
	});
	return response;
};
